<div class="login-main-wrapper min-image-handel m-0 p-4">
  <div class="left-side">
    <div class="logo">
      <img src="assets/images/img/logo-main.png" alt="logo">
    </div>
    <div class="inner-wrapper min-image-handel-card">
      <!-- <div class="">
      <app-left-layout></app-left-layout>
    </div> -->
      <div class="login-right-side">
        <div class="">
          <h3 class="main-heading fw-600">We Help Businesses Collect Outstanding Debt</h3>
          <div class="d-flex align-items-center login-signup-toggle gap-4">
            <button class="fs-16 fw-400 m-0 text-center" [routerLink]="'/login'" routerLinkActive="router-link-active">
              Sign In
            </button>
            <button class="fs-16 fw-400 m-0 text-center" [routerLink]="'/register'"
              routerLinkActive="router-link-active">
              Sign Up
            </button>
          </div>
          <!-- <app-google-translate></app-google-translate> -->
          <div class="right-content  p-3 p-lg-0">
            <div class="">
              <p class="fs-16 fw-400 text-secondary">
                Enter your email and password to continue
              </p>
            </div>

            <form (submit)="login()" [formGroup]="loginForm" class="col-12 example-form">

              <div class=" form-group mt-0 mb-3">
                <div
                  [ngClass]="[ (loginForm.controls['email'].touched && loginForm.controls['email'].invalid) ? 'custom-form  inputContainer' : 'custom-form']"
                  class="input-relative">
                  <input type="email" class="w-100" name="email" required formControlName="email"  [attr.autocomplete]="'new-email-' + randomString"
                  readonly (focus)="removeReadonly($event)"/>
                  <label for="text" class="label-name fs-14 w-100" [class.top-label]="!!loginForm.controls['email'].value">
                    Email address
                  </label>
                </div>
                <p class="mat-error text-danger w-100 d-block mb-0 fs-14"
                  *ngIf="(loginForm.controls['email'].touched && loginForm.controls['email'].invalid)">
                  {{loginForm.controls['email'].errors ? 'Enter a valid email (a-z, 0-9, &#64; only)' : ''}} </p>
              </div>


              <div class=" form-group">
                <div
                  [ngClass]="[ (loginForm.controls['password'].touched && loginForm.controls['password'].invalid)? 'custom-form  inputContainer' : 'custom-form']"
                  class="input-relative position-relative">

                  <!-- <div class="position-relative "> -->
                  <input [type]="!hidePwd ? 'password':'text'" class=" w-100" name="password" autocomplete="off"
                    required formControlName="password" />
                  <!-- </div> -->
                  <label for="text" class="label-name fs-14 w-100">
                    Password
                  </label>
                  <img [src]="hidePwd ? 'assets/images/icons/open-eye.svg' : 'assets/images/icons/close-eye.svg'" alt=""
                    class="position-absolute eye-icon cursor" (click)="hidePwd = !hidePwd">
                </div>

                <p class="mat-error text-danger w-100 d-block fs-14"
                  *ngIf="((loginForm.controls['password'].invalid && loginForm.controls['password'].touched))">
                  {{( (loginForm.controls['password'].errors) || (loginForm.controls['password'].invalid &&
                  loginForm.controls['password'].touched)) ? 'Please enter a valid Password' : ''}}</p>
                  <p
                  class="mat-error text-danger w-100 d-block fs-14"
                  *ngIf="loginForm.hasError('credentialsMismatch')"
                >
                <!-- {{data.original_text}} -->
                  {{this.errorMessage}}
                </p>
              </div>
              <div class="mt-4 w-100 forgot-pass text-left" style="height: 52px;">
                <p routerLink="/forgot-password" class="fw-400 cursor  d-block fs-14">
                  Forgot Password?
                </p>
              </div>

              <div class="mt-4">
                <button autofocus button-primary-auth type="submit"
                  class="w-100 border-0 mb-3 btn btn-primary fs-18 fw-500">Sign In</button>
              </div>
            </form>

            <app-google-sign-in></app-google-sign-in>


          </div>
        </div>
      </div>
    </div>
    <div class="align-items-center d-flex flex-wrap justify-content-between terms-condition-wrap gap-2">
      <div class="left">
        <p class="fs-14 fw-300 mb-0">
          ©{{_shared.epoch}} Recuvery LLC. All rights reserved.
        </p>
      </div>
      <div class="right">
        <ul class="d-flex align-items-center gap-2 mb-0 policy--listing">
          <li class="fs-14 fw-400">
            <a href="{{env.websiteUrl}}privacy-policy" target="_blank">Privacy Policy</a>
          </li>
          <li>•</li>
          <li class="fs-14 fw-400">
            <a href="{{env.websiteUrl}}terms-and-conditions" target="_blank"> Terms & Conditions</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="min-image-handel-card left-card-wrapper d-none  p-0">
    <div class="login-left--wrapper">
      <div class="image-div">
        <img class="main-image" src="assets/images/img/main-image.png" alt="login register">
      </div>
      <!-- <img src="assets/images/img/backgound-main.png"> -->
      <div class="bottom-content">
        <div class="left d-flex gap-2 align-items-center">
          <img src="assets/images/img/call-icon.png">
          <p class="mb-0 fw-500 fs-16">Call us at <span>+1 (833) 904-7001</span></p>
        </div>
        <div class="right btn-group gap-3">
          <a class="fw-500 fs-16 btn btn-white" href="https://www.recuvery.com/demo-scheduler/"
          target="_blank">Book a Demo</a>
          <button class="fw-500 fs-16 btn btn-black d-none">
            <img src="assets/images/img/player-play-filled.png">
            <span>Watch Video</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>